<script setup>
import '@/assets/cloudCounter/css/style.css';
import { computed, onMounted, ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import { useRouter } from 'vue-router';
import { postCheckReserveDatetimePeriodApply } from '@/apis/CloudECounterReserve';
import routeName from '@/router/constant';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';
import Loading from '@/components/Loading.vue';
import { postCecRecord, postCancelTransaction } from '@/apis/record';
import { convertCaseBoxList, setBoxData } from '@/views/cloudECounter/reserve/record/caseBoxUtils';
import { useStore } from 'vuex';
// import { cancelTransaction } from '@/apis/system';
import applicantField from '@/views/cloudECounter/reserve/record/applicantField';

const store = useStore();

const router = useRouter();
const goNextPage = () => {
    if (!canVideo.value) {
        return;
    }
    isLoading.value = true;
    postCheckReserveDatetimePeriodApply().then(res => {
        router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_VIDEO });
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
};

const getChineseDigits = (num) => {
    if (num >= 0 && num < 10) {
        return ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'][num];
    }
    return '';
};
const isLoading = ref(true);
const regiNo = computed(() => store.state.permissions.userInfo?.reserveVideo?.regiNo);

const record = ref({
    boxList: [{ list: [] }],
});
const policyInfo = ref({});
const canCancel = ref(false);
const canVideo = ref(false);

// #region 生存保險金受益人
const beneficiaries = ref([]);

// #endregion

// #region 滿期保險金
const maturedInfo = ref([]);

// #endregion

// #region 死亡保險金
const deathBenefitInfo = ref([]);
// #endregion

const infoBoxVisble = ref(false);

const endoresmentContent = ref({
    boxList: [{
        title: '本次變更批註寄送方式',
        list: [{
            key: '',
            value: '',
        }],
    }],
});
const isDeathAnnuity = ref(false);

const changedContact = ref({
    boxList: []
})

const rightTerms = ref({
    boxList: []
})

const okHandel = () => {
    isLoading.value = true;
    postCancelTransaction(regiNo.value).then(res => {
        openPopup('已完成取消預約申請');
        canCancel.value = false;
        canVideo.value = false;
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
};
onMounted(() => {
    postCecRecord(regiNo.value).then(res => {
        record.value.boxList = convertCaseBoxList(res.data, applicantField.record);
        policyInfo.value = setBoxData(res?.data?.fullPolicyNo, `${res?.data?.item} ${res?.data?.itemName}`);
        const a = res.data.beneficiaryChange.after;

        const beneficiariesGroupByOrders = groupByOrders(a.beneficiariesList);
        Object.keys(beneficiariesGroupByOrders).forEach(orderKey => {
            const boxList = [];
            beneficiariesGroupByOrders[orderKey].forEach(p => {
                boxList.push({
                    title: p.name,
                    list: [
                        ...(p.engName ? [{
                            key: '英文姓名',
                            value: p.engName,
                        },] : []),
                        {
                            key: '身分證號碼',
                            value: p.beneFiId,
                        },
                        {
                            key: '與被保險人的關係',
                            value: p.relation,
                        },
                        {
                            key: '出生日期',
                            value: p.birthday,
                        },
                        {
                            key: '國籍',
                            value: p.country,
                        },
                        ...(p.headBankNo ? [{
                            key: '受益人匯款帳號',
                            value: `${p.headBankNo} ${p.branchBankNo} <br>${p.bankAccount}`,
                        },] : []),
                        {
                            key: '受益人分配比例',
                            value: p.shareType === "2" ? "均分" : `${p.percentage}%`,
                        },
                    ],
                },)
            })
            beneficiaries.value.push({ boxList: boxList });
        })

        const maturedInfoGroupByOrders = groupByOrders(a.maturedInfoList);
        Object.keys(maturedInfoGroupByOrders).forEach(orderKey => {
            const boxList = [];
            maturedInfoGroupByOrders[orderKey].forEach(p => {
                boxList.push({
                    title: p.name,
                    list: [
                        ...(p.engName ? [{
                            key: '英文姓名',
                            value: p.engName,
                        },] : []),
                        {
                            key: '身分證號碼',
                            value: p.beneFiId,
                        },
                        {
                            key: '與被保險人的關係',
                            value: p.relation,
                        },
                        {
                            key: '出生日期',
                            value: p.birthday,
                        },
                        {
                            key: '國籍',
                            value: p.country,
                        },
                        ...(p.headBankNo ? [{
                            key: '受益人匯款帳號',
                            value: `${p.headBankNo} ${p.branchBankNo} <br>${p.bankAccount}`,
                        },] : []),
                        {
                            key: '受益人分配比例',
                            value: p.shareType === "2" ? "均分" : `${p.percentage}%`,
                        },
                    ],
                },)
            })
            maturedInfo.value.push({ boxList: boxList });
        })

        const deathBenefitGroupByOrders = groupByOrders(a.deathBenefitInfoList);
        Object.keys(deathBenefitGroupByOrders).forEach(orderKey => {
            const boxList = [];
            deathBenefitGroupByOrders[orderKey].forEach(p => {
                boxList.push({
                    title: p.name,
                    list: [
                        ...(p.engName ? [{
                            key: '英文姓名',
                            value: p.engName,
                        },] : []),
                        ...(p.beneFiId ? [{
                            key: '身分證號碼',
                            value: p.beneFiId,
                        },] : []),
                        {
                            key: '與被保險人的關係',
                            value: p.relation,
                        },
                        ...(p.birthday ? [{
                            key: '出生日期',
                            value: p.birthday,
                        },] : []),
                        {
                            key: '國籍',
                            value: p.country,
                        },
                        ...(p.address ? [{
                            key: '地址',
                            value: `${p.city} ${p.cityArea} <br>${p.address}`,
                        },] : []),
                        ...(p.mobile ? [{
                            key: '行動電話',
                            value: p.mobile,
                        },] : []),
                        {
                            key: '受益人分配比例',
                            value: p.shareType === "2" ? "均分" : `${p.percentage}%`,
                        },
                    ],
                },)
            });
            deathBenefitInfo.value.push({ boxList: boxList });
        });

        canCancel.value = res.data.canCancel;
        canVideo.value = res.data.canVideo;
        endoresmentContent.value.boxList[0].list[0].value = res.data?.endorsementDesc;
        isDeathAnnuity.value = res.data?.beneficiaryChange?.isDeathAnnuity === 'Y';

        if (res.data.beneficiaryChange?.insMobile?.mobile) {
            changedContact.value.boxList.push({
                title: '要保人行動電話',
                list: [{
                    key: '行動電話',
                    value: res.data.beneficiaryChange?.insMobile?.mobile
                }]
            })
        }

        if (res.data.beneficiaryChange?.insEmail) {
            changedContact.value.boxList.push({
                title: '要保人E-mail',
                list: [{
                    key: 'E-mail',
                    value: res.data.beneficiaryChange?.insEmail
                }]
            })
        }

        if (res.data.beneficiaryChange?.insuredMobile) {
            changedContact.value.boxList.push({
                title: '被保險人行動電話',
                list: [{
                    key: '行動電話',
                    value: res.data.beneficiaryChange?.insuredMobile?.mobile
                }]
            })
        }

        let rightText = '1.依契約條款規定無該項保險金時，填寫之受益人仍不生效力。';
        // 非視訊件且有變更電話 or Email才出現
        if (res.data.beneficiaryChange?.notMeeting && (res.data.beneficiaryChange?.insMobile?.mobile || res.data.beneficiaryChange?.insEmail)) {
            rightText += '<br>2.本人(即要保人)亦同意向貴公司投保之所有個人險有效及停效保單的行動電話號碼/Email一併同時更新如上。';
        }
        rightTerms.value.boxList.push({
            title: '本次變更權利義務說明及相關注意/約定事項',
            list: [{
                value: rightText,
            }]
        })
    }).catch(ex => {
        console.log(ex);
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
});

const groupByOrders = (list) => {
    if (!list) return {};
    const result = list.reduce((acc, item) => {
        const orderKey = Number(item.orders); // 將 orders 轉換為數字
        if (!acc[orderKey]) {
            acc[orderKey] = []; // 如果不存在，則初始化為空陣列
        }
        acc[orderKey].push(item); // 將當前物件推入對應的 orders 陣列中
        return acc;
    }, {});
    return result;
}
</script>

<template>
    <div>
        <!-- 要保人變更 -->
        <Layout :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

            <div class="pt-2 pb-6">
                <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="1"></Process>
            </div>

            <div class="pb-6">
                <h2 class="pb-3 text-2xl font-bold">
                    申請紀錄
                </h2>
                <CaseBox :caseBox="record" />
            </div>

            <h2 class="pb-3 text-2xl font-bold">
                申請明細
            </h2>

            <div class="pb-6">
                <h3 class="pb-4 text-xl font-bold">
                    申請保單
                </h3>
                <CaseBox :caseBox="policyInfo" />
            </div>

            <div v-if="beneficiaries.length > 0" class="pb-6">
                <h3 class="pb-4 text-xl font-bold">
                    生存保險金受益人
                </h3>
                <div :class="{ 'pt-2': i !== 0 }" v-for="(caseBox, i) in beneficiaries" :key="i">
                    <h4 class="pb-4 text-lg font-bold">
                        第{{ getChineseDigits(i) }}順位
                    </h4>
                    <CaseBox :caseBox="caseBox" />
                </div>
            </div>

            <div v-if="maturedInfo.length > 0" class="pb-6">
                <h3 class="pb-4 text-xl font-bold">
                    滿期保險金受益人
                </h3>
                <div :class="{ 'pt-2': i !== 0 }" v-for="(caseBox, i) in maturedInfo" :key="i">
                    <h4 class="pb-4 text-lg font-bold">
                        第{{ getChineseDigits(i) }}順位
                    </h4>
                    <CaseBox :caseBox="caseBox" />
                </div>
            </div>

            <div v-if="deathBenefitInfo.length > 0" class="pb-6">
                <h3 class="pb-4 text-xl font-bold">
                    {{ isDeathAnnuity ? "身故後年金受益人" : "身故保險金受益人" }}
                </h3>
                <div :class="{ 'pt-2': i !== 0 }" v-for="(caseBox, i) in deathBenefitInfo" :key="i">
                    <h4 class="pb-4 text-lg font-bold">
                        第{{ getChineseDigits(i) }}順位
                    </h4>
                    <CaseBox :caseBox="caseBox" />
                </div>
            </div>

            <div v-if="changedContact.boxList.length > 0" class="pb-2">
                <CaseBox :caseBox="changedContact" />
            </div>

            <div class="pb-2">
                <CaseBox :caseBox="endoresmentContent" />
            </div>

            <div class="pb-2">
                <CaseBox :caseBox="rightTerms" />
            </div>

            <div v-if="canCancel" class="text-center">
                <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true }">取消預約申請
                </button>
            </div>

            <template v-slot:bottom>
                <button
                    class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                    :class="canVideo ? '' : 'bg-gray-300'" @click="goNextPage">開始視訊
                </button>
            </template>
            <Loading :is-loading="isLoading" />
        </Layout>

        <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？"
            type="confirm" :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }" />
    </div>
</template>

<style scoped></style>
